import { Layout } from "antd";
import styled from "styled-components";

export const Container = styled(Layout.Footer)`
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
